// Structured data for the Tips page
export const tipsPageData = {
  // Hero section
  hero: {
    title: "Pro Tips",
    image: "/img/tips-hero-desktop.png",
    mobileImage: "/img/tips-hero-mobile.png"
  },
  
  // Influencers section
  influencers: {
    title: "wd-40 BRAND® pros",
    pills: [
      "Automotive",
      "Construction/DIY",
      "Machine Repair & Operations"
    ],
    gallery: [
      {
        id: "infl-1",
        url: "/img/tips-page/gallery01.png",
        alt: "Automotive Expert - Throtl",
        title: "Throtl",
        category: "Automotive",
        details: {
          headerImage: "/img/tips-page/throtl-header.png",
          name: "THROTL",
          prefix: "MEET",
          category: "AUTOMOTIVE",
          profileImage: "/img/tips-page/gallery01.png",
          introText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
          socialMedia: [
            {
              platform: "instagram",
              url: "https://www.instagram.com/throtl/"
            },
            {
              platform: "twitter",
              url: "https://twitter.com/throtl"
            },
            {
              platform: "youtube",
              url: "https://www.youtube.com/c/throtl"
            },
            {
              platform: "facebook",
              url: "https://www.facebook.com/throtl/"
            }
          ],
          video: {
            thumbnailUrl: "/img/tips-page/throtl-video-thumb.jpg",
            videoUrl: "https://files.wd40.com/video/WD40_DesktopScreenHomeVideo.mp4",
            title: "Throtl's Latest Project"
          },
          favoriteProducts: {
            title: "THROTL'S FAVORITE PRODUCTS",
            products: [
              {
                id: "prod-1",
                name: "WD-40 Specialist Gel Lube",
                image: "/img/products/gel-lube.png",
                url: "/products/specialist-gel-lube"
              },
              {
                id: "prod-2",
                name: "WD-40 Specialist Silicone",
                image: "/img/products/silicone.png",
                url: "/products/specialist-silicone"
              },
              {
                id: "prod-3",
                name: "WD-40 Specialist Penetrant",
                image: "/img/products/penetrant.png",
                url: "/products/specialist-penetrant"
              }
            ]
          }
        }
      },
      {
        id: "infl-2",
        url: "/img/tips-page/gallery02.png",
        alt: "DIY Expert",
        title: "Throtl",
        category: "Construction/DIY",
        details: {
          headerImage: "/img/tips-page/throtl-header.png",
          name: "DIY EXPERT",
          prefix: "MEET",
          category: "CONSTRUCTION/DIY",
          profileImage: "/img/tips-page/gallery02.png",
          introText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          socialMedia: [
            {
              platform: "instagram",
              url: "https://www.instagram.com/"
            },
            {
              platform: "youtube",
              url: "https://www.youtube.com/"
            },
            {
              platform: "facebook",
              url: "https://www.facebook.com/"
            }
          ],
          video: {
            thumbnailUrl: "/img/tips-page/throtl-video-thumb.jpg",
            videoUrl: "https://files.wd40.com/video/WD40_DesktopScreenHomeVideo.mp4",
            title: "DIY Expert's Latest Project"
          },
          favoriteProducts: {
            title: "DIY EXPERT'S FAVORITE PRODUCTS",
            products: [
              {
                id: "prod-1",
                name: "WD-40 Multi-Use",
                image: "/img/products/multi-use.png",
                url: "/products/multi-use"
              },
              {
                id: "prod-2",
                name: "WD-40 Specialist Silicone",
                image: "/img/products/silicone.png",
                url: "/products/specialist-silicone"
              }
            ]
          }
        }
      },
      {
        id: "infl-3",
        url: "/img/tips-page/gallery03.png",
        alt: "Machine Repair Expert",
        title: "Throtl",
        category: "Machine Repair & Operations",
        details: {
          headerImage: "/img/tips-page/throtl-header.png",
          name: "MACHINE REPAIR EXPERT",
          prefix: "MEET",
          category: "MACHINE REPAIR & OPERATIONS",
          profileImage: "/img/tips-page/gallery03.png",
          introText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          socialMedia: [
            {
              platform: "instagram",
              url: "https://www.instagram.com/"
            },
            {
              platform: "twitter",
              url: "https://twitter.com/"
            },
            {
              platform: "youtube",
              url: "https://www.youtube.com/"
            }
          ],
          video: {
            thumbnailUrl: "/img/tips-page/throtl-video-thumb.jpg",
            videoUrl: "https://files.wd40.com/video/WD40_DesktopScreenHomeVideo.mp4",
            title: "Machine Repair Expert's Latest Project"
          },
          favoriteProducts: {
            title: "MACHINE REPAIR EXPERT'S FAVORITE PRODUCTS",
            products: [
              {
                id: "prod-1",
                name: "WD-40 Specialist Penetrant",
                image: "/img/products/penetrant.png",
                url: "/products/specialist-penetrant"
              },
              {
                id: "prod-2",
                name: "WD-40 Multi-Use",
                image: "/img/products/multi-use.png",
                url: "/products/multi-use"
              }
            ]
          }
        }
      },
      {
        id: "infl-4",
        url: "/img/tips-page/gallery01.png",
        alt: "Automotive Expert",
        title: "Automotive Expert",
        category: "Automotive",
        details: {
          headerImage: "/img/tips-page/throtl-header.png",
          name: "AUTOMOTIVE EXPERT",
          prefix: "MEET",
          category: "AUTOMOTIVE",
          profileImage: "/img/tips-page/gallery01.png",
          introText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          socialMedia: [
            {
              platform: "instagram",
              url: "https://www.instagram.com/"
            },
            {
              platform: "facebook",
              url: "https://www.facebook.com/"
            }
          ],
          video: {
            thumbnailUrl: "/img/tips-page/throtl-video-thumb.jpg",
            videoUrl: "https://files.wd40.com/video/WD40_DesktopScreenHomeVideo.mp4",
            title: "Automotive Expert's Latest Project"
          },
          favoriteProducts: {
            title: "AUTOMOTIVE EXPERT'S FAVORITE PRODUCTS",
            products: [
              {
                id: "prod-1",
                name: "WD-40 Multi-Use",
                image: "/img/products/multi-use.png",
                url: "/products/multi-use"
              },
              {
                id: "prod-2",
                name: "WD-40 Specialist Silicone",
                image: "/img/products/silicone.png",
                url: "/products/specialist-silicone"
              }
            ]
          }
        }
      },
      {
        id: "infl-5",
        url: "/img/tips-page/gallery02.png",
        alt: "DIY Expert",
        title: "DIY Expert",
        category: "Construction/DIY",
        details: {
          headerImage: "/img/tips-page/throtl-header.png",
          name: "DIY EXPERT",
          prefix: "MEET",
          category: "CONSTRUCTION/DIY",
          profileImage: "/img/tips-page/gallery02.png",
          introText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          socialMedia: [
            {
              platform: "instagram",
              url: "https://www.instagram.com/"
            },
            {
              platform: "youtube",
              url: "https://www.youtube.com/"
            }
          ],
          video: {
            thumbnailUrl: "/img/tips-page/throtl-video-thumb.jpg",
            videoUrl: "https://files.wd40.com/video/WD40_DesktopScreenHomeVideo.mp4",
            title: "DIY Expert's Latest Project"
          },
          favoriteProducts: {
            title: "DIY EXPERT'S FAVORITE PRODUCTS",
            products: [
              {
                id: "prod-1",
                name: "WD-40 Multi-Use",
                image: "/img/products/multi-use.png",
                url: "/products/multi-use"
              },
              {
                id: "prod-2",
                name: "WD-40 Specialist Penetrant",
                image: "/img/products/penetrant.png",
                url: "/products/specialist-penetrant"
              }
            ]
          }
        }
      },
      {
        id: "infl-6",
        url: "/img/tips-page/gallery03.png",
        alt: "Machine Repair Expert",
        title: "Machine Repair Expert",
        category: "Machine Repair & Operations",
        details: {
          headerImage: "/img/tips-page/throtl-header.png",
          name: "MACHINE REPAIR EXPERT",
          prefix: "MEET",
          category: "MACHINE REPAIR & OPERATIONS",
          profileImage: "/img/tips-page/gallery03.png",
          introText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          socialMedia: [
            {
              platform: "instagram",
              url: "https://www.instagram.com/"
            },
            {
              platform: "youtube",
              url: "https://www.youtube.com/"
            }
          ],
          video: {
            thumbnailUrl: "/img/tips-page/throtl-video-thumb.jpg",
            videoUrl: "https://files.wd40.com/video/WD40_DesktopScreenHomeVideo.mp4",
            title: "Machine Repair Expert's Latest Project"
          },
          favoriteProducts: {
            title: "MACHINE REPAIR EXPERT'S FAVORITE PRODUCTS",
            products: [
              {
                id: "prod-1",
                name: "WD-40 Specialist Penetrant",
                image: "/img/products/penetrant.png",
                url: "/products/specialist-penetrant"
              },
              {
                id: "prod-2",
                name: "WD-40 Multi-Use",
                image: "/img/products/multi-use.png",
                url: "/products/multi-use"
              }
            ]
          }
        }
      }
    ]
  },
  
  // Product section
  productSection: {
    title: "stock up here",
    background: "/img/tips-page/products-bg.png",
    galleryImages: [
      {
        id: "silicone",
        url: "/img/tips-page/silicone.png",
        alt: "WD-40 Specialist Silicone",
        title: "Silicone Quick-Drying",
        productUrl: "/products/silicone-lubricant"
      },
      {
        id: "gel-lube",
        url: "/img/tips-page/gel-lube.png",
        alt: "WD-40 Specialist Gel Lube",
        title: "Gel Lube No-Drip",
        productUrl: "/products/spray-gel"
      },
      {
        id: "penetrant",
        url: "/img/tips-page/penetrant.png",
        alt: "WD-40 Specialist Penetrant",
        title: "Penetrant Fast-Acting",
        productUrl: "/products/penetrating-oil"
      }
    ]
  },
  
  // Uses section
  usesSection: {
    amount: 2000,
    title: "Uses and Applications",
    uses: [
      "Restores shine on classic cars",
      "Helps remove window tint",
      "Shines car tires",
      "Lubricates gear shifters",
      "Quiets squeaky windshield wipers",
      "Loosens frozen boat parts",
      "Removes sap from boat frames",
      "Unsticks stuck boat horns",
      "Drives moisture from precision tools",
      "Frees stuck locks",
      "Loosens rusted bolts",
      "Removes rust from saws",
      "Prevents corrosion on tools",
      "Removes gunk from blades",
      "Stops squeaks on garage doors",
      "Keeps glue gun triggers from sticking",
      "Removes duct tape",
      "Polishes silver jewelry",
      "Removes crayon from place mats",
      "Helps remove ketchup stains"
    ]
  },
  
  // Blog section
  blogSection: {
    title: "SEVEN DECADES OF KNOW-HOW",
    articles: [
      {
        id: "blog-1",
        title: "10 Household Uses for WD-40",
        excerpt: "Discover surprising ways to use WD-40 around your home.",
        categories: ["HOUSEHOLD", "TIPS"],
        image: "/img/tips-page/gallery01.png",
        url: "/blog/household-uses"
      },
      {
        id: "blog-2",
        title: "Automotive Maintenance Tips",
        excerpt: "Keep your vehicle running smoothly with these expert tips.",
        categories: ["AUTOMOTIVE", "MAINTENANCE"],
        image: "/img/tips-page/gallery02.png",
        url: "/blog/automotive-tips"
      },
      {
        id: "blog-3",
        title: "DIY Project Hacks",
        excerpt: "Make your next DIY project easier with these professional hacks.",
        categories: ["DIY", "PROJECTS"],
        image: "/img/tips-page/gallery03.png",
        url: "/blog/diy-hacks"
      },
      {
        id: "blog-4",
        title: "10 Household Uses for WD-40",
        excerpt: "Discover surprising ways to use WD-40 around your home.",
        categories: ["HOUSEHOLD", "TIPS"],
        image: "/img/tips-page/gallery01.png",
        url: "/blog/household-uses"
      },
      {
        id: "blog-5",
        title: "Automotive Maintenance Tips",
        excerpt: "Keep your vehicle running smoothly with these expert tips.",
        categories: ["AUTOMOTIVE", "MAINTENANCE"],
        image: "/img/tips-page/gallery02.png",
        url: "/blog/automotive-tips"
      },
      {
        id: "blog-6",
        title: "DIY Project Hacks",
        excerpt: "Make your next DIY project easier with these professional hacks.",
        categories: ["DIY", "PROJECTS"],
        image: "/img/tips-page/gallery03.png",
        url: "/blog/diy-hacks"
      }
    ]
  }
};

export default tipsPageData;
